import React from 'react'

const Checkmark = (): React.ReactElement => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.43.403a.75.75 0 0 1 .143 1.052l-7.62 10a.75.75 0 0 1-1.22-.039L.876 7.13a.75.75 0 1 1 1.248-.832L4.398 9.71 11.38.546a.75.75 0 0 1 1.05-.143Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Checkmark
